import Vue from "vue"
import App from "./App.vue"
import moment from "moment"
import "moment-timezone"
import router from "./router"
import store, {vxm} from "./store"
import "./styles/main.scss"

moment.tz.setDefault("Asia/Tokyo");

(async () => {

  Vue.config.productionTip = false

  Vue.filter("datef", (value: string, format: string = "YYYY/MM/DD HH:mm") => {

    const m = moment(value, moment.ISO_8601)
    if (m.isValid()) {
      return m.format(format)
    } else {
      return ""
    }
  })


  await vxm.auth.initialize()

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app")
})()
